import { gql } from 'graphql.macro';

export const transportOrderFragment = gql`
    fragment transportOrderFields on TransportOrder {
        _id
        clinic {
            _id
        }
        manualPackageCount
        actualPackageCount
        deadline
        status
        hasProblem
        serviceCode
        externalReference
        comment
        internalMessage
        transportDate
        transportProvider {
            channel
            externalId
            code
        }
        pickup {
            name
            countryCode
            streetAddress
            zipCode
            city
        }
        delivery {
            name
            countryCode
            streetAddress
            zipCode
            city
        }
        orders {
            _id
            orderId
            patient {
                personalIdentityNumber
                firstName
                lastName
            }
        }
        isSameDayDelivery
    }
`;

export const transportOrderSuperAdminFragment = gql`
    fragment transportOrderSuperAdminFields on TransportOrder {
        ...transportOrderFields
        lab {
            name
            contact {
                address {
                    street
                    postalCode
                    city
                    country
                }
            }
        }
        clinic {
            name
            contact {
                address {
                    street
                    postalCode
                    city
                    country
                }
            }
        }
    }
    ${transportOrderFragment}
`;

export const nShiftPartnerServiceAddonFragment = gql`
    fragment nShiftPartnerServiceAddonFields on NShiftPartnerServiceAddon {
        id
        description
    }
`;

export const nShiftPartnerServiceFragment = gql`
    fragment nShiftPartnerServiceFields on NShiftPartnerService {
        id
        description
        addons {
            ...nShiftPartnerServiceAddonFields
        }
    }
    ${nShiftPartnerServiceAddonFragment}
`;
